let serverTimeAtSyncMs = 0;
let perfAtSyncMs = 0;
let synced = false;

function perfNowMs(): number {
  const perf = (globalThis as { performance?: { now: () => number } })
    .performance;
  return perf?.now() ?? Date.now();
}

/**
 * Records the server time anchored to `performance.now()`.
 * Called once when the server time API response arrives.
 */
export function setSyncedTime(serverMs: number): void {
  serverTimeAtSyncMs = serverMs;
  perfAtSyncMs = perfNowMs();
  synced = true;
}

export function isClockSynced(): boolean {
  return synced;
}

/**
 * Returns current server time in milliseconds.
 * Uses a monotonic clock (`performance.now()`) so changing the system
 * clock after sync has zero effect.
 *
 * Falls back to `Date.now()` before sync so Genius deeplink / render paths
 * (ExamScreen, Starting Soon, `toSchedule`) do not crash when
 * ServerClockProvider has not finished; prefer gating UI on `isClockSynced()`.
 */
export function serverNow(): number {
  if (!synced) return Date.now();
  return serverTimeAtSyncMs + (perfNowMs() - perfAtSyncMs);
}
